import React, { useEffect, useState } from 'react'
import { MdDashboard } from 'react-icons/md'
import { PiInvoice } from 'react-icons/pi'
import { GrProjects } from 'react-icons/gr'
import { FaCashRegister } from 'react-icons/fa'
import { MdPayments } from 'react-icons/md'
import { FaReceipt } from 'react-icons/fa'
import { FaUsers } from 'react-icons/fa'
import { CiBank } from 'react-icons/ci'
import { IoIosSwap } from 'react-icons/io'
import { MdEvent } from 'react-icons/md'
import { FaUserSecret } from 'react-icons/fa'
import { FaChartBar } from 'react-icons/fa'
import { FaBars, FaTimes, FaUser } from 'react-icons/fa'
import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../context/auth-context'
import axios from 'axios'
import { rootUrl } from '../helpers'
import { GrUserAdmin } from 'react-icons/gr'
import { FaSignOutAlt } from 'react-icons/fa'   
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { FaBuilding } from 'react-icons/fa'
import { FaMap, FaMapMarkedAlt } from 'react-icons/fa'
import { FaShoppingCart } from 'react-icons/fa'

function Revenue() {


    const auth = useAuth();

    const [allData, setAllData] = useState([]) 
    const routes = [
        { path: '/revenue', name: 'Dashboard', icon: MdDashboard },
        { path: '/revenue/bills', name: 'Bills', icon: PiInvoice },
        { path: '/revenue/properties', name: 'Properties', icon: FaBuilding },
        { path: '/revenue/land', name: 'Land Management', icon: FaMap },
        { path: '/revenue/land-management', name: 'GIS Map', icon: FaMapMarkedAlt },
        { path: '/revenue/shops', name: 'Shops', icon: FaShoppingCart },
        { path: '/revenue/customers', name: 'Receipts', icon: FaReceipt },
        { path: '/revenue/clients', name: 'Clients', icon: FaUsers },
        { path: '/revenue/reports', name: 'Reports', icon: FaChartBar },
      ];

      const getGen = async () =>{
        try{
          const response = await axios.get(rootUrl(`/getGeneral/${auth.user?.id}`))
          if(response.data.status == 200){
               setAllData(response.data.data)
          }
        }catch(e){
          // toast.error(e?.message)
        }
      }

      useEffect(()=>{
        getGen()
      }, [])

      const [isSidebarOpen, setIsSidebarOpen] = useState(false);
      const location = useLocation();
      const currentUrl = location.pathname + location.search;
    
      const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
      };
    
      const signOut = () => {
        auth.logOut(()=>{
           window.location.href = "/"
        })
    
      }
 
return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:static inset-y-0 left-0 z-50
          w-64 bg-gradient-to-b from-blue-950 to-blue-900 text-white
          transform transition-transform duration-300 ease-in-out
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
          flex flex-col shadow-2xl
        `}
      >
        {/* Sidebar Header */}
        <div className="p-6 border-b border-blue-800">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="bg-white/20 rounded-lg p-2">
                <img src="/logo1.png" alt="Logo" className="w-8 h-8 object-contain" />
              </div>
              <div>
                <h2 className="font-bold text-lg">Revenue</h2>
                <p className="text-xs text-blue-200">Management System</p>
              </div>
            </div>
            <button
              onClick={toggleSidebar}
              className="lg:hidden p-2 hover:bg-white/10 rounded-lg transition-colors"
            >
              <FaTimes className="text-white" />
            </button>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto px-4 py-4">
          <p className="text-xs font-semibold text-blue-300 uppercase tracking-wider mb-3 px-3">
            Navigation
          </p>
          <ul className="space-y-1">
            {routes.map((route) => {
              const isActive = currentUrl === route.path;
              const Icon = route.icon;
              return (
                <li key={route.path}>
                  <NavLink
                    to={route.path}
                    onClick={() => setIsSidebarOpen(false)}
                    className={`
                      flex items-center gap-3 px-4 py-3 rounded-lg
                      transition-all duration-200
                      ${
                        isActive
                          ? 'bg-white text-blue-950 shadow-lg font-semibold'
                          : 'text-blue-100 hover:bg-white/10 hover:text-white'
                      }
                    `}
                  >
                    <Icon className={isActive ? 'text-blue-950 text-lg' : 'text-blue-300 text-lg'} />
                    <span>{route.name}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Sidebar Footer - User Info & Logout */}
        <div className="p-4 border-t border-blue-800">
          <div className="flex items-center gap-3 mb-3 px-2">
            <div className="bg-white/20 rounded-full p-2">
              <FaUser className="text-white text-sm" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white truncate">
                {auth.user?.name || 'Revenue User'}
              </p>
              <p className="text-xs text-blue-200 truncate">
                {auth.user?.email || 'revenue@gramosi.com'}
              </p>
            </div>
          </div>
          <button
            onClick={signOut}
            className="w-full flex items-center gap-3 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors font-medium text-sm"
          >
            <FaSignOutAlt />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Header */}
        <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-sm border-b border-gray-200 shadow-sm">
          <div className="px-4 lg:px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <button
                  onClick={toggleSidebar}
                  className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <FaBars className="text-gray-700 text-xl" />
                </button>
                <div>
                  <h1 className="text-xl md:text-2xl font-bold text-gray-900">
                    {allData.council ? allData.council[0]?.name : 'Revenue Management'}
                  </h1>
                  <p className="text-sm text-gray-500 hidden sm:block">
                    Revenue collection and management system
                  </p>
                </div>
              </div>
              
              <div className="flex items-center gap-2">
                {auth?.user?.userType == 2 && (
                  <NavLink
                    to={'/admin'}
                    className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors relative"
                    title="Go to Admin Dashboard"
                  >
                    <GrUserAdmin className="text-gray-700 text-xl" />
                  </NavLink>
                )}
                <div className="hidden sm:flex items-center gap-3 ml-2 pl-3 border-l border-gray-200">
                  <div className="bg-blue-950 rounded-full p-2">
                    <FaUser className="text-white text-sm" />
                  </div>
                  <div className="hidden md:block">
                    <p className="text-sm font-medium text-gray-900">
                      {auth.user?.name || 'User'}
                    </p>
                    <p className="text-xs text-gray-500">Revenue Officer</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content Area */}
        <main
          className={`flex-1 min-h-0 overflow-y-auto overflow-x-hidden ${
            currentUrl.startsWith('/revenue/land-management')
              ? 'p-0'
              : 'px-4 lg:px-6 py-4 lg:py-6'
          }`}
        >
          <div
            className={
              currentUrl.startsWith('/revenue/land-management')
                ? 'w-full h-full'
                : 'max-w-7xl mx-auto w-full'
            }
          >
            {allData.budget === undefined ? (
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8">
                <div className="max-w-4xl mx-auto">
                  <Skeleton count={6} height={100} className="mb-4" />
                </div>
              </div>
            ) : (
              <Outlet context={{ allData, setAllData }} />
            )}
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 px-4 lg:px-6 py-4">
          <div className="max-w-7xl mx-auto">
            <p className="text-center text-sm text-gray-600">
              &copy; {new Date().getFullYear()} Gramosi. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Revenue